export type PaidMediaTabId =
  | "overview"
  | "meta-ads-report"
  | "google-ads-report"
  | "tiktok-ads-report";

export const PAID_MEDIA_TAB_ITEMS: Array<{ id: PaidMediaTabId; label: string }> = [
  { id: "overview", label: "Paid Media Overview" },
  { id: "meta-ads-report", label: "Meta Ads Report" },
  { id: "google-ads-report", label: "Google Ads Report" },
];

export const PAID_MEDIA_TAB_IDS: PaidMediaTabId[] = PAID_MEDIA_TAB_ITEMS.map(tab => tab.id);

export const PAID_MEDIA_TAB_I18N_KEYS: Record<PaidMediaTabId, string> = {
  overview: "metaAdsReport.paidMediaTabs.overview",
  "meta-ads-report": "metaAdsReport.paidMediaTabs.metaAdsReport",
  "google-ads-report": "metaAdsReport.paidMediaTabs.googleAdsReport",
  "tiktok-ads-report": "metaAdsReport.paidMediaTabs.comingSoon",
};
